import React from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import dreamImg from '../../../Assets/images/DFL/landing-page-img/engagment-static-page-img/dream-rings.png'
import '../../../Assets/css/engRingStaticPage.css'
import { NavLink } from 'react-router-dom'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'

const ShopForFineDiamond = () => {
    const history = useHistory()
    return (
        <>
            <div className='dfl_dream_rings_section'>
                <Container>
                    <Row>
                    <Col sm={12} md={6} lg={6} className='p-0'>
                            <div className='dfl_dream_rings_img_box'>
                            
                            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d92374.9487127337!2d-79.4494563!3d43.6540529!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d4cb34a5006187%3A0x7d775a6a5641f2d!2sDiamonds%20For%20Less!5e0!3m2!1sen!2sin!4v1669802682368!5m2!1sen!2sin" width="100%" height="450" style={{ border: "0" }} allowfullscreen="" loading="lazy"></iframe>
                                                  
                            </div>
                        </Col>
                        <Col sm={12} md={6} lg={6} className='d-flex align-items-center'>
                            <div className='dfl_dream_rings_text_box'>
                                <h2>Shop for Fine Diamond Jewellery in Toronto</h2>
                                <p>Visit our store in Toronto to get your hands on a wide range of exceptionally
crafted diamond jewellery. Whether you want jewelry from our off-the-shelf
collection or opt for customisation, we do it all.</p>
                                <button className='btn_design_your_ring' onClick={() => history.push("/make-an-appointment")}>Book An Appointment</button>
                            </div>
                        </Col>
                    
                    </Row>
                </Container>
            </div>
        </>

    )
}

export default ShopForFineDiamond